/**
 * "Parcela atual" do parcelado no Web, com a mesma regra do form do app (`app/transactions/[id].tsx`):
 * a compra já em andamento entra da parcela atual em diante, sem retroativo. A Data do form é a
 * da parcela atual; cada seguinte cai um mês depois. O valor de cada parcela sai do TOTAL da
 * compra (`getInstallmentAmountForNumber`), então a 3/10 de R$ 1.000,00 vale R$ 100,00 mesmo
 * sem a 1 e a 2 no banco. No cartão quem cria é o `createInstallment` (`startInstallmentNumber`);
 * em conta, o form usa este plano.
 */
import { addMonths, format, parse } from 'date-fns';
import { getInstallmentAmountForNumber, roundCurrency } from '@/lib/installments';

export interface PlannedInstallment { number: number; amount: number; date: string }

/** Parcela atual digitada → número válido, ou null se estiver fora de 1..count. Vazio = 1. */
export function parseCurrentInstallment(text: string, count: number): number | null {
  const raw = text.trim();
  if (!raw) return 1;
  const n = Number(raw);
  if (!Number.isInteger(n) || n < 1 || n > count) return null;
  return n;
}

/** As parcelas que nascem: da `current` até `count`, a primeira na `date`. */
export function planInstallments(total: number, count: number, current: number, date: string): PlannedInstallment[] {
  const start = parse(date, 'yyyy-MM-dd', new Date());
  const out: PlannedInstallment[] = [];
  for (let i = current; i <= count; i++) {
    out.push({
      number: i,
      amount: getInstallmentAmountForNumber(total, count, i),
      date: format(addMonths(start, i - current), 'yyyy-MM-dd'),
    });
  }
  return out;
}

/** Resumo da prévia: quantas parcelas entram, o valor da atual e a soma do que entra. */
export function installmentPreview(total: number, count: number, current: number): { times: number; amount: number; sum: number } {
  const plan = planInstallments(total, count, current, '2000-01-01');
  return { times: plan.length, amount: plan[0]?.amount ?? 0, sum: roundCurrency(plan.reduce((s, p) => s + p.amount, 0)) };
}
